import { IconTooltipItem, PrettyOrgUser } from '~/domain';
import { OrgUserDto, OrgUserProfileDto, OrganizationProfileDto, UserBaseDto } from '~/services';

import { formatDate } from './date.helpers';

type UserContext = {
	orgProfileMap: Map<string, OrganizationProfileDto>;
};

export function getProfileIcon(profileId: string, orgProfileMap: Map<string, OrganizationProfileDto>): IconTooltipItem {
	const foundOrgProfile = orgProfileMap?.get(profileId);
	if (!foundOrgProfile) {
		return null;
	}

	return {
		icon: foundOrgProfile.iconRef?.substring(3),
		label: foundOrgProfile.labels?.fr
	};
}

export function getProfileIcons(profiles: OrgUserProfileDto[], orgProfileMap: Map<string, OrganizationProfileDto>): IconTooltipItem[] {
	return profiles?.map(profile => getProfileIcon(profile.profileId, orgProfileMap)).filter(profile => !!profile) ?? [];
}

export function computeFullName({ firstName, lastName }: Pick<UserBaseDto, 'firstName' | 'lastName'>) {
	return lastName && firstName ? `${firstName} ${lastName}` : undefined;
}

export function asPrettyOrgUser(user: OrgUserDto, context: UserContext): PrettyOrgUser {
	return {
		...user,
		fullName: computeFullName(user),
		rights: getProfileIcons(user?.profiles, context?.orgProfileMap),
		formattedSyncAt: formatDate(user?.synchronizedAt),
		blocked: !!user?.blockedAt
	};
}
